import { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { ReactComponent as DownArrow } from '../assets/icons/down-select.svg'
import { ReactComponent as Dot } from '../assets/icons/dot.svg'
import { ReactComponent as Add } from '../assets/icons/add.svg'
// import { dayList, subjectList, courseList } from '../assets/data'
import ClassCard from '../components/ClassCard'
import { getSchools, getSchoolsSemester } from '../apis/school.ts'
import { getCourses } from '../apis/course.ts'
import { dayEnumList } from '../assets/data.js'

export default function Class() {
  const [semesterList, setSemesterList] = useState()
  const [semesterId, setSemesterId] = useState()
  const [courseList, setCourseList] = useState()

  const sortedByList = [
    { id: 1, name: '과목별', type: 'SUBJECT' },
    { id: 2, name: '요일별', type: 'DAY_OF_WEEK' },
  ]
  const [sortedBy, setSortedBy] = useState(1)

  const getSchoolsApi = async () => {
    const getSchoolsResponse = await getSchools()

    if (getSchoolsResponse.error) {
      console.log(getSchoolsResponse)
      return
    } else {
      // console.log(getSchoolsResponse.data)
    }
  }

  const getSchoolsSemesterApi = async () => {
    const getSchoolsSemesterResponse = await getSchoolsSemester()

    if (getSchoolsSemesterResponse.error) {
      console.log(getSchoolsSemesterResponse)
      return
    } else {
      // console.log(getSchoolsSemesterResponse.data.nowSemester)
      setSemesterList(getSchoolsSemesterResponse.data)
      setSemesterId(getSchoolsSemesterResponse.data.nowSemester.id)
      // setSemesterId(getSchoolsSemesterResponse.data.semesters[1].id)
    }
  }

  const getCoursesApi = async (semesterId) => {
    const getCoursesResponse = await getCourses({
      categoryType: getCategoryType(sortedBy),
      semesterId: semesterId,
    })

    if (getCoursesResponse.error) {
      console.log(getCoursesResponse)
      return
    } else {
      setCourseList(getCoursesResponse.data)
    }
  }

  const getCategoryType = (id) => {
    const item = sortedByList.find((item) => item.id === id)
    return item.type
  }

  useEffect(() => {
    getSchoolsApi()
    getSchoolsSemesterApi()
    // getCoursesApi()
  }, [])

  useEffect(() => {
    if (semesterId) {
      getCoursesApi(semesterId)
    }
    // eslint-disable-next-line
  }, [semesterId, sortedBy])

  const findItem = (list, id) => {
    const item = list?.find((item) => item?.id === id)
    return item
  }
  // console.log(semesterList)
  return (
    <div className='h-full w-full'>
      <div className='mb-40'>
        <div className='mb-20 flex justify-between'>
          <div className='flex items-center gap-20'>
            <p className='text-title2-bold text-label-strong'>수업 관리</p>
            <div className='flex items-center gap-12'>
              <div className='relative flex min-w-min cursor-pointer items-center'>
                <select
                  onChange={(e) => {
                    setSemesterId(e.target.value)
                  }}
                  className='cursor-pointer pr-20 text-body1-medium text-label-sub outline-none'
                >
                  {/* <option disabled selected>
                    {semesterList?.nowSemester?.name}
                  </option> */}
                  {semesterList?.semesters?.map((semesterItem, semesterIndex) => (
                    <option
                      key={semesterIndex}
                      value={semesterItem.id}
                      disabled={Boolean(semesterItem.courseCount === 0)}
                      selected={Boolean(
                        semesterItem.id === semesterList?.semesters,
                        semesterList?.nowSemester?.id,
                      )}
                    >
                      {semesterItem.name}
                    </option>
                  ))}
                </select>
                <DownArrow className='pointer-events-none absolute right-0 cursor-pointer' />
              </div>
            </div>
          </div>
          {courseList?.length > 0 && findItem(semesterList?.semesters, semesterId).editAllow && (
            <Link
              to={'/class/add'}
              state={findItem(semesterList?.semesters, semesterId)}
              className='button_outlined_primary_md flex items-center gap-[5px] fill-primary-normal'
            >
              <Add />
              <p className='text-button-medium text-primary-normal'>수업 추가</p>
            </Link>
          )}
        </div>
        <div className='flex items-center gap-16'>
          {sortedByList.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                setSortedBy(item.id)
                // getCoursesApi()
              }}
              className={`flex cursor-pointer items-center justify-center gap-4 ${
                sortedBy === item.id
                  ? 'fill-label-sub text-label-sub'
                  : 'fill-label-placeholder text-label-placeholder'
              }`}
            >
              <Dot />
              <p className='text-body3-medium'>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
      {courseList?.length === 0 ? (
        <div className='h-full w-full'>
          <div className='flex h-full w-full flex-col items-center justify-center gap-40'>
            <div className='text-center text-h1-medium text-label-info'>
              <p className='mb-4'>진행중인 수업이 없습니다!</p>
              <p>수업을 추가해주세요!</p>
            </div>
            <Link
              to={'/class/add'}
              state={findItem(semesterList?.semesters, semesterId)}
              className='button_solid_primary_lg bg-mint-50 fill-inverse-label'
            >
              <Add />
              <p className='text-inverse-label'>수업 추가</p>
            </Link>
          </div>
        </div>
      ) : (
        <div className='flex flex-col gap-40'>
          {courseList?.map((item, courseIndex) => (
            <div key={courseIndex} className='flex flex-col gap-20'>
              <div className='flex items-center'>
                <div className='flex items-center gap-8'>
                  <p className='text-h1-semibold text-static-black'>
                    {sortedBy === 2 ? dayEnumList[item.name] : item.name}
                  </p>
                  <p className='text-h2-semibold text-primary-normal'>{item.courses.length}</p>
                </div>
              </div>
              <div className='flex w-full flex-wrap gap-20'>
                {item.courses.map((courseItem, courseIndex) => (
                  <ClassCard key={courseIndex} courses={courseItem} />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
